import { useMenuSettings } from '../../contexts/MenuSettingsContext';
import PageSwitch from '../../components/common/PageSwitch';
import SpendLeakage from '../SpendLeakage';
import PriceVariancePage from '../price-variance/PriceVariancePage';

/**
 * Spend — leakage (invoice lines outside the supplier's approved commodities)
 * and price variance (invoice lines against contract rates), one sidebar item.
 */
export default function SpendPage() {
  const { isFeatureEnabled, isMenuItemVisible } = useMenuSettings();
  return (
    <PageSwitch
      testId="spend-tabs"
      tabs={[
        { value: 'leakage', label: 'Spend Leakage', element: <SpendLeakage />, visible: isFeatureEnabled('spend_leakage') },
        { value: 'variance', label: 'Price Variance', element: <PriceVariancePage />, visible: isMenuItemVisible('priceVariance') },
      ]}
    />
  );
}
